<template>
  <div class="mb-img-field">
    <span :class="['mb-img-field__thumb', {'is-fallback': !value && fallback}]">
      <img v-if="shown && !broken" :src="shown" alt="" @error="broken = true">
      <i v-else class="fa fa-picture-o"></i>
    </span>
    <input :id="id"
           class="mb-input mb-input--sm mb-img-field__url"
           :value="value"
           :placeholder="placeholder"
           inputmode="url"
           @input="$emit('input', $event.target.value)">
    <input ref="file" type="file" accept="image/*" hidden @change="upload">
    <button type="button" class="mb-btn mb-btn--ghost mb-btn--sm" :disabled="uploading" @click="$refs.file.click()">
      {{ uploading ? 'Загружаем…' : 'Загрузить' }}
    </button>
    <button v-if="value" type="button" class="mb-link mb-link--danger" @click="$emit('input', '')">Сбросить</button>
  </div>
</template>

<script>
import api from '@/api/api'

/**
 * Картинка для правки трансляции: ссылка вручную или загрузка через file-upload (постоянная публичная ссылка).
 * Пустое значение — правки нет, показываем fallback (данные Moonton / нашей команды) полупрозрачным.
 */
export default {
  name: 'MbImageField',
  props: {
    value: {type: String, default: ''},
    fallback: {type: String, default: ''},
    placeholder: {type: String, default: 'https://…'},
    id: {type: String, default: undefined},
  },
  data() {
    return {uploading: false, broken: false}
  },
  computed: {
    shown() {
      return this.value || this.fallback || ''
    },
  },
  watch: {
    shown() {
      this.broken = false
    },
  },
  methods: {
    async upload(e) {
      const file = e.target.files && e.target.files[0]
      e.target.value = ''
      if (!file) return
      this.uploading = true
      try {
        const form = new FormData()
        form.append('image', file)
        const res = await api.storeImage.store(form)
        const url = res?.data?.url || res?.data?.data?.url
        if (url) this.$emit('input', url)
      } catch (err) {
        // тост покажет интерсептор
      } finally {
        this.uploading = false
      }
    },
  },
}
</script>

<style lang="scss">
.mb-img-field {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;

  &__thumb {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: none;
    width: 34px;
    height: 34px;
    overflow: hidden;
    border-radius: 8px;
    background: var(--tl-soft-2);
    color: var(--tl-muted);

    img { width: 100%; height: 100%; object-fit: cover; }
    &.is-fallback img { opacity: .45; }
  }

  &__url { flex: 1 1 auto; min-width: 0; }
  .mb-btn, .mb-link { flex: none; }
}
</style>
